// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3nKFU","inner":"Form_inner__2npq5","range":"Form_range__3dEGI","name":"Form_name__kMVX9","actions":"Form_actions__1-aYi"};